export const ROUTER_NAMES = {
  /** ログイン画面 */
  login: 'Login',
  /** 自治体管理者ユーザー管理画面 */
  orgAdminManagement: 'OrgAdminManagement',
  /** 団体管理者ユーザー管理画面 */
  orgMemberManagement: 'OrgMemberManagement',
  /** アップロード（被災家屋）画面 */
  uploadAeroPic: 'UploadAeroPic',
  /** 固定資産アップロード画面 */
  uploadPropertyTax: 'UploadPropertyTax'
} as const
